import { apiClient } from '@/lib/api/api-client';

const BASE = '/api/freight-leg-pricings';

export interface FreightRouteLegProviderPricing {
  id: string;
  tenantId: string;
  legId: string;
  providerId: string;
  // Tarifas opcionales — el proveedor puede cotizar en una o varias formas.
  // El usuario elige cuál aplicar al cotizar el tramo en una orden.
  ratePerKg: number | string | null;
  ratePerCbm: number | string | null;
  flatAmount: number | string | null;
  currency: string;
  minimumCharge: number | string | null;
  estimatedDays: number | null;
  validFrom: string;
  validUntil: string | null;
  notes: string | null;
  isActive: boolean;
  provider?: { id: string; name: string };
  leg?: {
    id: string;
    origin: string;
    destination: string;
    transportMode: string;
    legType: string;
  };
  createdAt: string;
  updatedAt: string;
}

export interface CreateLegPricingDto {
  legId: string;
  providerId: string;
  ratePerKg?: number | null;
  ratePerCbm?: number | null;
  flatAmount?: number | null;
  currency?: string;
  minimumCharge?: number | null;
  estimatedDays?: number | null;
  notes?: string | null;
}

export interface UpdateLegPricingDto {
  ratePerKg?: number | null;
  ratePerCbm?: number | null;
  flatAmount?: number | null;
  currency?: string;
  minimumCharge?: number | null;
  estimatedDays?: number | null;
  notes?: string | null;
}

export interface LegPricingsBundle {
  leg: {
    id: string;
    origin: string;
    destination: string;
    transportMode: string;
    legType: string;
  };
  active: FreightRouteLegProviderPricing[];
  history: FreightRouteLegProviderPricing[];
}

export const freightLegPricingsService = {
  /** Lista precios. Por defecto sólo activos. Pasar includeHistory=true para incluir cerrados. */
  list: (filter?: { legId?: string; providerId?: string; includeHistory?: boolean }) => {
    const qs = new URLSearchParams();
    if (filter?.legId) qs.set('legId', filter.legId);
    if (filter?.providerId) qs.set('providerId', filter.providerId);
    if (filter?.includeHistory) qs.set('includeHistory', 'true');
    const tail = qs.toString() ? `?${qs.toString()}` : '';
    return apiClient.get<FreightRouteLegProviderPricing[]>(`${BASE}${tail}`);
  },

  /** Devuelve activos + historial agrupado para un leg específico. */
  getByLeg: (legId: string) => apiClient.get<LegPricingsBundle>(`${BASE}/legs/${legId}`),

  create: (dto: CreateLegPricingDto) => apiClient.post<FreightRouteLegProviderPricing>(BASE, dto),

  /** Actualiza versionando: cierra el activo y crea uno nuevo. */
  update: (id: string, dto: UpdateLegPricingDto) =>
    apiClient.patch<FreightRouteLegProviderPricing>(`${BASE}/${id}`, dto),

  /** Soft delete: cierra el activo (validUntil=now, isActive=false). */
  remove: (id: string) => apiClient.delete<void>(`${BASE}/${id}`),
};
